(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["__LR__limits-manager"] = factory();
	else
		root["__LR__limits-manager"] = factory();
})(self, () => {
return 